import { render, staticRenderFns } from "./GenericFaqTabs.vue?vue&type=template&id=44cc0571&scoped=true"
import script from "./GenericFaqTabs.vue?vue&type=script&lang=js"
export * from "./GenericFaqTabs.vue?vue&type=script&lang=js"
import style0 from "./GenericFaqTabs.vue?vue&type=style&index=0&id=44cc0571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cc0571",
  null
  
)

export default component.exports